import { useAppSelector } from 'common/hooks/redux'
import { useParams } from 'react-router'
import { useFetchProceduresQuery } from 'features/Procedure/state/procedure.api'
import { ProcedureTypeCode } from 'features/Procedure/state/procedure.type'
import type { ProcedureItem, HistoricalDataItem } from 'features/Procedure/state/procedure-api.type'

export const useDiagnosisFormat = ({
  justifyCodes = [],
  historical = false,
  selectedEncounterUid: selectedEncounterUidProp,
}: {
  justifyCodes: string[]
  historical?: boolean
  selectedEncounterUid?: string
}) => {
  const encounterUid = useAppSelector((state) => state.procedureReducer.selectedEncounterUid)
  const selectedEncounterUid = selectedEncounterUidProp ?? encounterUid
  const { siteId } = useParams()

  const { data: proceduresData } = useFetchProceduresQuery(
    {
      siteId,
      encounterUid: selectedEncounterUid,
    },
    {
      skip: !selectedEncounterUid,
    },
  )
  const uniqueCodes = justifyCodes
    ?.map((code) => {
      return code.split('|')[1]
    })
    ?.filter(Boolean)

  const formatData = () => {
    const items: (ProcedureItem | HistoricalDataItem)[] | undefined = historical
      ? proceduresData?.historical_procedures?.items?.flatMap((encounter) => encounter.items)
      : proceduresData?.items

    const diagnosisFormat = []
    uniqueCodes?.forEach((code) => {
      const procedure = items?.find(
        (proc) => proc.code === code && proc.code_type === ProcedureTypeCode.ICD10,
      )
      if (procedure) {
        diagnosisFormat.push(`${procedure.code_text.trim()}|${procedure.code}`)
      }
    })
    return diagnosisFormat
  }

  const diagnosisFormat = formatData()
  return {
    diagnosisFormat,
  }
}
